<app-ref-list #list [page]="page()" />
